import React from "react"
import Heading from "../../../../components/dashboard/heading-component/Heading";
import {Col, Row} from "react-bootstrap"
import {GDateIcon, GStarIcon} from "../../../../../assets/icons/cardIcons";
import HeadingSkeleton from "../../../../components/skeletons/HeadingSkeleton";

export default function JournalDetailsSkeleton() {

    return(

        <div className={'journal-details'}>

            <div>
                <Heading back={true} heading={'Journals'}/>
                <Row className={'flex-column-reverse flex-md-row mt-5 '}>
                    <Col md={8}>
                        <div className={'journal-detail-card'}>
                            <p>
                                <HeadingSkeleton height={10} maxWidth={100}/>
                                <span>
                                    <HeadingSkeleton height={10} maxWidth={100}/>
                                </span>
                            </p>
                            <div>
                                {
                                    [190,200,800,400,600,100,800,300,600].map((item,index)=>{
                                        return(
                                                <h5 className={'mt-4 mb-4'} key={index}> <HeadingSkeleton height={15} maxWidth={item}/></h5>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className={'icon-box'}>
                            <div className={'icon'}>
                                <GDateIcon/>
                            </div>
                            <div className={'content'}>
                                <h5>Date</h5>
                                <p>  <HeadingSkeleton height={20} maxWidth={120}/></p>
                            </div>
                        </div>
                        <div className={'icon-box'}>
                            <div className={'icon'}>
                                <GStarIcon/>
                            </div>
                            <div className={'content'}>
                                <h5>Type</h5>
                                <p>  <HeadingSkeleton height={20} maxWidth={120}/></p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>


    )
}